import { Camera, CameraFields, CameraProperties } from '../../core/Camera';
import { Vector3 } from 'three';
import { PerspectiveCamera } from '@react-three/drei';
import { forwardRef, useImperativeHandle, useRef, useEffect } from 'react';
import * as THREE from 'three';

// Create a reusable Camera component that can be used in both preview and world
const CameraComponent = forwardRef<THREE.PerspectiveCamera, { properties: CameraProperties; isPreview?: boolean }>((props, ref) => {
  const { properties, isPreview } = props;
  const { position, lookAt } = properties;
  const localRef = useRef<THREE.PerspectiveCamera>(null);

  // Forward the ref to parent
  useImperativeHandle(ref, () => localRef.current!, []);

  // Update camera position and lookAt
  useEffect(() => {
    if (localRef.current) {
      // Update position
      localRef.current.position.copy(position);
      
      // Force camera to look at target
      localRef.current.lookAt(lookAt);
      localRef.current.updateMatrixWorld();
    }
  }, [position, lookAt]);

  // In preview mode, use simplified position
  const initialPosition = isPreview ? [0, 2, 5] : [position.x, position.y, position.z];

  return (
    <PerspectiveCamera
      ref={localRef}
      makeDefault={!isPreview}
      position={initialPosition as [number, number, number]}
      fov={75}
      near={0.1}
      far={1000}
    />
  );
});

export const CameraItem: Camera = {
  id: '',
  name: 'Camera',
  type: 'camera',
  icon: 'Camera',
  properties: {
    position: new Vector3(0, 2, 5),
    lookAt: new Vector3(0, 0, 0),
  },
  fields: [
    ...CameraFields,
  ],
  render: (properties: CameraProperties, isPreview: boolean) => {
    return <CameraComponent properties={properties} isPreview={isPreview} />;
  }
};